import apiAction from "common/redux/actions/apiAction";
import { POST_DELEGATE_DELETE, POST_DELEGATE_SAVE, POST_DELEGATE_SWITCH, POST_DELEGATE_USER_VIEW, POST_DELEGATE_USERLIST } from "./apiPathConstants";
import { logError } from "TAP/utils/commonMethods";

const getSearchedUserList = (data) => {
    return {
        type: 'GET_SEARCHED_USER_LIST',
        payload: data
    }
}

const saveDelegate = (data) => {
    return {
        type: 'SAVE_DELEGATE',
        payload: data
    }
}

const getDelegateUserView = (data) => {
    return {
        type: 'GET_DELEGATE_USER_VIEW',
        payload: data
    }
}
const getDelegateDeletedRes = (data) => {
    return {
        type: 'GET_DELEGATE_DELETE',
        payload: data
    }
}

const getDelegateSwitchRes = (data) => {
    return {
        type: 'GET_DELEGATE_SWITCH',
        payload: data
    }
}

export const clearDeleteSuccessMessage = (data) => {
    return {
        type: 'CLEAR_DELEGATE_DELETE',
        payload: data
    }
}

export const DelegateSearchedUserList = (bodyData) => {
    return apiAction.postAPI({
        url: POST_DELEGATE_USERLIST(),
        data: bodyData,
        onSuccess: getSearchedUserList,
        onFailure: (err) => logError('Error Showing Alert Data.:', err),
        label: 'GET_SEARCHED_USER_LIST',
    });
}
export const DelegateUserSave = (bodyData) => {
    return apiAction.postAPI({
        url: POST_DELEGATE_SAVE(),
        data: bodyData,
        onSuccess: saveDelegate,
        onFailure: (err) => logError('Error Showing Alert Data.:', err),
        label: 'SAVE_DELEGATE'
    })
}
export const DelegateUserView = (bodyData) => {
    return apiAction.postAPI({
        url: POST_DELEGATE_USER_VIEW(),
        data: bodyData,
        onSuccess: getDelegateUserView,
        onFailure: (err) => logError('Error Showing Alert Data.:', err),
        label: 'GET_DELEGATE_USER_VIEW'
    })
}
export const DelegateDelete = (bodyData) => {
    return apiAction.postAPI({
        url: POST_DELEGATE_DELETE(),
        data: bodyData,
        onSuccess: getDelegateDeletedRes,
        onFailure: (err) => logError('Error Showing Alert Data.:', err),
        label: 'GET_DELEGATE_DELETE'
    })
}

export const DelegateSwitch = (bodyData) => {
    return apiAction.postAPI({
        url: POST_DELEGATE_SWITCH(),
        data: bodyData,
        onSuccess: getDelegateSwitchRes,
        onFailure: (err) => logError('Error Showing Alert Data.:', err),
        label: 'GET_DELEGATE_SWITCH'
    })
}